module.exports = __webpack_public_path__ + "img/wp6.24a47d22.jpeg";